<template>
  <div class="cards">
    <div
      class="card"
      v-for="(item, i) in list"
      :key="i"
      @click="routerTo(item)"
    >
      <img v-if="item.icon" :src="item.icon" alt="" />
      <h5 class="card-title">{{ item.title }}</h5>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive } from "vue";
import msg_icon from "../assets/svg/msg_icon.svg";
import msg_admin_icon from "../assets/svg/msg_admin_icon.svg";
// import music_icon from "../assets/svg/music_icon.svg";
import nft_icon from "../assets/svg/nft_icon.svg";
// import dpksh_icon from "../assets/svg/dpksh_icon.svg";
import foot_icon from "../assets/svg/foot_icon.svg";

const list = reactive([
  {
    title: "小新留言板",
    icon: msg_icon,
    url: "http://www.shli617.top",
  },
  {
    title: "留言板管理端",
    icon: msg_admin_icon,
    url: "http://shli617.top/admin/",
  },
  {
    title: "来时的足迹",
    icon: foot_icon,
    url: "http://note.shli617.top",
  },
  {
    title: "NFT铸造",
    icon: nft_icon,
    url: "http://nft.shli617.top",
  },
  // {
  //   title: "大屏可视化示例",
  //   icon: dpksh_icon,
  //   url: "http://shli617.top:8089",
  // },
]);

const routerTo = (item) => {
  if (item.url) {
    window.open(item.url, "_blank");
  }
};
</script>

<style lang="scss" scoped>
.cards {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  .card {
    position: relative;
    height: 200px;
    border-radius: 10px;
    cursor: url(~@/assets/img/link.cur), pointer;
    transition: all 0.2s ease;
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.25);
      border-radius: 10px;
      filter: blur(2px);
    }
    &:hover {
      transform: translate(1px, 1px);
    }
    & > img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, calc(-50% - 18px));
      width: 80px;
    }
    .card-title {
      position: absolute;
      bottom: 25px;
      text-align: center;
      width: calc(100% - 30px);
      left: 15px;
      font-family: "alfont";
      font-size: 20px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
</style>
